export function calculateSiteIDMapping(locations) {
    if (locations && locations.length > 0) {
        return locations.reduce((siteSlugs, location) => {
            siteSlugs[location.site_id] = location.slug;
            return siteSlugs;
        }, {});
    }
    return undefined;
}
export function getLocationsByEdgeMarkets(edgeMarkets, consumerAPI) {
    if (!edgeMarkets) {
        return [];
    }
    const locationsByEdgeMarkets = edgeMarkets.reduce((allLocations, edgeMarket) => {
        let locations;
        if (consumerAPI) {
            const { edge_locations: edgeLocations } = edgeMarket;
            locations = edgeLocations.map(location => location.name);
        }
        else {
            ({
                locations
            } = edgeMarket);
        }
        return [...allLocations, ...locations];
    }, []);
    return locationsByEdgeMarkets;
}
